// Free plan (one-time credits, entitlements D49): when the balance hits zero, tool calls
// are paused (402 credits_exhausted). Shown on every page from GET /entitlements —
// `calls.quota_kind == 'credits'` and the balance is live (not `unused`) and 0 — with
// the server's remedy and the upsell link. A 402 anywhere re-reads entitlements, so
// the banner appears as soon as the gateway starts refusing.
import { useCredits } from './index'
import { UpsellLink } from './PlanNote'

export function CreditsBanner() {
  const credits = useCredits()
  if (!credits?.exhausted) return null
  return (
    <div className="credits-banner" role="alert" aria-label="Out of credits">
      <p>
        <strong>This workspace is out of free credits.</strong> Tool calls are paused. {credits.remedy}{' '}
        <UpsellLink />
      </p>
    </div>
  )
}
